import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import Actions from "../../../redux/Actions";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardNavigation from "./OnboardNavigation";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import {
    applySortOrderToYearGroupingIsAfterValues,
    SchoolWorkloadConfig,
    sortYearGroupingsByIsAfterValues,
    YearGrouping
} from "../../../models/SchoolWorkloadConfig";
import ApiService from "../../ApiService";
import * as _ from "lodash";
import {MessageBarType, PrimaryButton} from "office-ui-fabric-react";
import YearGroupingSuggestions, {YearGroupingSuggestion} from "./YearGroupingSuggestions";
import YearGroupingEditor from "../../YearGroupingsEditor";
import School from "../../../models/School";

interface OnboardYearGroupingPageProps {
    tenantId: string;
    schoolCode: string;
    
    apiService: ApiService;
    history: History;
}

interface OnboardYearGroupingPageState {
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    yearGroupingItems: YearGrouping[];
    aggregatePermissions: boolean;
}

class OnboardYearGroupingPage extends Component<OnboardYearGroupingPageProps & DispatchProps, OnboardYearGroupingPageState> {

    constructor(props: OnboardYearGroupingPageProps & DispatchProps) {
        super(props);
        this.state = {
            schoolWorkloadConfig: undefined,
            yearGroupingItems: [],
            aggregatePermissions: true
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId)
        {
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);
            this.setState({
                schoolWorkloadConfig
            });
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardYearGroupingPageProps & DispatchProps>, prevState: OnboardYearGroupingPageState): Promise<void> {
        if(this.state.schoolWorkloadConfig !== prevState.schoolWorkloadConfig) {
            
            const yearGroupingItems = _.cloneDeep(this.state.schoolWorkloadConfig?.yearGroupings?.items || []);
            this.setState({
                yearGroupingItems: sortYearGroupingsByIsAfterValues(yearGroupingItems)
            });
        }
    }
    
    private onSuggestionSelected = (suggestion: YearGroupingSuggestion): void => {
        
        const yearGroupingItems = suggestion.yearGroupingNames.map((name: string) => {
            return {name: name} as YearGrouping
        });
        
        this.setState({
            yearGroupingItems
        });
    };
    
    private save = async (): Promise<boolean> => {
        if(this.state.schoolWorkloadConfig === undefined) {
            return false;
        }
        
        const updatedConfig = _.cloneDeep(this.state.schoolWorkloadConfig);
        
        applySortOrderToYearGroupingIsAfterValues(this.state.yearGroupingItems);
        
        updatedConfig.yearGroupings.items = this.state.yearGroupingItems;

        if (this.state.aggregatePermissions) {
            updatedConfig.yearGroupings.aggregatePermissions = true;
        }
        
        const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId,this.props.schoolCode,updatedConfig);
        
        this.setState({
            schoolWorkloadConfig: savedSchoolWorkloadConfig
        });

        await this.props.dispatch(Actions.showMessageBar("Saved year groupings to config",MessageBarType.success));
        
        return true;
    }

    public render(): JSX.Element {
        
        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={"year-grouping"}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className="onboard-timeline-content">
                                    <div className="flex-item--flex-1 flex-column flex--align-items-center">

                                        {this.state.schoolWorkloadConfig?.yearGroupings.items.length === 0 ? <YearGroupingSuggestions onSuggestionSelected={this.onSuggestionSelected}/> : null}

                                        <h3>Your Year Groupings</h3>
                                        {this.state.yearGroupingItems ?
                                            <YearGroupingEditor yearGroupings={this.state.yearGroupingItems}
                                                                onYearGroupingChange={(yearGroups: YearGrouping[]) => {
                                                                    this.setState({yearGroupingItems: yearGroups})
                                                                }}
                                                                aggregatePermissions={this.state.aggregatePermissions}
                                                                onAggregatePermissionsChanged={(choice: boolean) => {
                                                                    this.setState({aggregatePermissions: choice})
                                                                }}
                                                                schoolWorkloadConfig={this.state.schoolWorkloadConfig}/> : null}

                                        <PrimaryButton style={{margin: "auto"}} onClick={this.save} text={`Save Changes`}/>
                                    </div>
                                </div>
                                <OnboardNavigation currentTimelineItemKey={"year-grouping"} timelineItems={timelineItems} completeItem={this.save}
                                                   enableNext={true} enableSave={false} history={this.props.history}
                                                   tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardYearGroupingPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardYearGroupingPage)